import { KeyOutlined } from '@ant-design/icons'
import KForm from 'app/components/Modules/Form/KForm'
import KInputText from 'app/components/Modules/Form/KInputText'
import { KFormProps } from 'app/components/Modules/Form/typing'
import Icon from 'app/components/UI-Elements/General/Icon'
import { RecordType } from 'app/constants/GlobalTypes'
import * as React from 'react'

const Form: React.FC<Partial<KFormProps>> = ({ onSuccess, ...others }) => (
  <KForm
    recordType={RecordType.session}
    layout="vertical"
    onSuccess={onSuccess}
    silentSuccess
    {...others}>
    <KInputText
      name="email"
      type="email"
      rules={[{ type: 'email' }]}
      style={{ maxHeight: '40px' }}
      suffix={<Icon type="user" style={{ height: '20px' }} />}
    />
    <KInputText name="password" type="password" suffix={<KeyOutlined />} />
  </KForm>
)

export default Form
